import { Column } from '../../column';
import { ProductCategoryType } from '../product-category-type';
import { ProductMacroCategoryType } from '../product-macro-category-type';
import { administeredColumns } from './administered-columns';
import { realEconomyColumns } from './real-economy-columns';
import { liquidityColumns } from './liquidity-columns';
import { managedColumns } from './managed-columns';
import { assetManagementColumns } from './asset-management-columns';
import { mobileAdministeredColumns } from './mobile-table/mobile-administered-columns';
import { mobileLiquidityColumns } from './mobile-table/mobile-liquidity-columns';
import { mobileManagedColumns } from './mobile-table/mobile-managed-columns';
import { mobileTraditionalInsuranceColumns } from './mobile-table/mobile-traditional-insurance-columns';
import { mobileTraditionalPoliciesRevaluedColumns } from './mobile-table/mobile-traditional-policies-revalued-columns';
import { mobileUnitLinkedAtPriceColumns } from './mobile-table/mobile-unit-linked-at-price-columns';
import { mobileUnitLinkedColumns } from './mobile-table/mobile-unit-linked-columns';
import { mobileWelfareColumns } from './mobile-table/mobile-welfare-columns';
import { traditionalInsuranceColumns } from './traditional-insurance-columns';
import { traditionalPoliciesRevaluedColumns } from './traditional-policies-revalued-columns';
import { unitLinkedAtPriceColumns } from './unit-linked-at-price-columns';
import { unitLinkedColumns } from './unit-linked-columns';
import { welfareColumns } from './welfare-columns';
import { mobileRealEconomyColumns, realEconomyDetailTable } from './mobile-table/mobile-realeconomy-columns';

export const retrieveColumnsForFinancialPositions = (
  macroCategoryType: ProductMacroCategoryType,
  categoryType: ProductCategoryType
): Column<any>[] => {
  switch (macroCategoryType) {
    case 'Managed':
      if (categoryType === 'AssetManagement') {
        return assetManagementColumns;
      }
      return managedColumns;
    case 'FinancialInsurance':
      switch (categoryType) {
        case 'UnitLinked':
          return unitLinkedColumns;
        case 'UnitLinkedAtPrice':
          return unitLinkedAtPriceColumns;
        default:
          return traditionalPoliciesRevaluedColumns;
      }
    case 'Welfare':
      return welfareColumns;
    case 'Administered':
      return administeredColumns;
    case 'Liquidity':
      return liquidityColumns;
    case 'RealEconomy':
      return realEconomyColumns;
    default:
      return traditionalInsuranceColumns;
  }
};

export const retrieveColumnsForMobileFinancialPositions = (
  macroCategoryType: ProductMacroCategoryType,
  categoryType: ProductCategoryType
): Column<any>[] => {
  switch (macroCategoryType) {
    case 'Managed':
      return mobileManagedColumns;
    case 'FinancialInsurance':
      switch (categoryType) {
        case 'UnitLinked':
          return mobileUnitLinkedColumns;
        case 'UnitLinkedAtPrice':
          return mobileUnitLinkedAtPriceColumns;
        default:
          return mobileTraditionalPoliciesRevaluedColumns;
      }
    case 'Welfare':
      return mobileWelfareColumns;
    case 'Administered':
      return mobileAdministeredColumns;
    case 'Liquidity':
      return mobileLiquidityColumns;
      case 'RealEconomy':
        return mobileRealEconomyColumns;
    default:
      return mobileTraditionalInsuranceColumns;
  }
};


export const retrieveColumnsForRealEconomyMobileFinancialPositions = (

): Column<any>[] => {
  return realEconomyDetailTable
}